import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import API_URL from "./api_url";

const app = createApp(App);
app.config.globalProperties.API_URL = API_URL;
app.use(router).mount("#app");
